// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"XBBH6","picS":"_3ncm6","picM":"_3tu63","textBox":"_24o67"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Kartbox/Kartbox.scss
 ** module id = 450
 ** module chunks = 0
 **/